<template>
  <div>
    <div class="text-center my-2 my-sm-6 my-md-12">
      <LinkLogo class="mx-auto" />
    </div>
    <v-sheet class="d-flex justify-space-between mx-auto mb-2 align-center" max-width="800">
      <ChangeLocale />
    </v-sheet>
    <v-sheet max-width="800" class="py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12 mx-auto mb-6" id="bordered-sheet">
      <v-sheet max-width="500" class="mx-auto">
        <slot></slot>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import LinkLogo from "@/components/common/LinkLogo"
import ChangeLocale from "@/components/common/ChangeLocale"

export default {
  components: {
    LinkLogo,
    ChangeLocale
  }
}
</script>

<style>
</style>